/*********************** Custom JS for Boost AI Search & Discovery  ************************/

if (window.boostSDAppConfig) {
    window.boostSDAppConfig.integration = Object.assign({
        wishlists: 'plus'
    }, window.boostSDAppConfig.integration || {});
}

/* Start boost 32222 */
if(window.boostSDAppConfig){
	window.boostSDAppConfig = {
    ...window.boostSDAppConfig,
  	themeInfo: {
      ...window.boostSDAppConfig.themeInfo,
    	taeFeatures: {
        ...window.boostSDAppConfig.themeInfo.taeFeatures,
      	instantSearch: "installed"
      }
    }
  }
}
/* End boost 32222 */

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('RecommendationWidget.Slider', {
            name: 'Fix wishlist plus integration',
            apply: () => ({
                afterRender(element) {
                    try {
                      const widgetElm = componentRegistry.getNearestParentElm(element, 'RecommendationWidget');
                      const widgetId = widgetElm?.getParams()?.props?.designSettings?.widgetId || '';
                      function swymCallbackFn(swat) {
                          // your API calls go here
                          document.addEventListener("swym:collections-loaded", function () {
                              swat.initializeActionButtons(`#boost-sd-widget-${widgetId} .slick-track`);
                          })
                      }
                      if (!window.SwymCallbacks) {
                          window.SwymCallbacks = [];
                      }
                      window.SwymCallbacks.push(swymCallbackFn);
                      setTimeout(() => {
                        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
                      }, 300)
                    } catch (error) {
                        console.warn(error)
                    }
                },
            }),
        });
    }
]);